import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { NFDateInput } from "src/components/Shared/NewForms/NFDateInput";
import { NFTextAreaInput } from "src/components/Shared/NewForms/NFTextAreaInput";
import { NFTextInput } from "src/components/Shared/NewForms/NFTextInput";

export const WriteOffGoodsDetailAdditional = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className={"panel-body tabs-menu-body main-content-body-right"}>
        <Row>
          <Col sm={12}>
            <NFTextAreaInput fieldName={"comment"} title={t("Comment")} required={false} />
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <NFTextInput title={t("CreatedUser")} fieldName={"createdUser"} disabled={true} />
          </Col>
          <Col sm={6}>
            <NFDateInput title={t("CreatedDate")} fieldName={"createdDate"} disabled={true} />
          </Col>
        </Row>
      </div>
    </>
  );
};
